import { startOfDay } from 'date-fns'

// The selected scheduling day is a floor in both flag states. Horizon
// anchoring can only move the search later, never back before that day.
export function slotRecommendationSearchFrom({
  horizonEnabled,
  horizonStart,
  selectedStart,
}: {
  horizonEnabled: boolean
  horizonStart?: string
  selectedStart?: string
}): string | undefined {
  const selectedDay = selectedStart
    ? startOfDay(selectedStart).toISOString()
    : undefined
  if (!horizonEnabled || !horizonStart) {
    return selectedDay
  }
  if (!selectedDay) {
    return horizonStart
  }
  if (Date.parse(horizonStart) > Date.parse(selectedDay)) {
    return horizonStart
  }
  return selectedDay
}
